export * as checkoutExchange from '@wix/auto_sdk_loyalty_checkout-exchange/schemas';
export * as imports from '@wix/auto_sdk_loyalty_imports/schemas';
export * as socialMedia from '@wix/auto_sdk_loyalty_social-media/schemas';
export * as transactions from '@wix/auto_sdk_loyalty_transactions/schemas';
export * as accounts from '@wix/auto_sdk_loyalty_accounts/schemas';
export * as coupons from '@wix/auto_sdk_loyalty_coupons/schemas';
export * as earningRules from '@wix/auto_sdk_loyalty_earning-rules/schemas';
export * as programs from '@wix/auto_sdk_loyalty_programs/schemas';
export * as rewards from '@wix/auto_sdk_loyalty_rewards/schemas';
export * as tiers from '@wix/auto_sdk_loyalty_tiers/schemas';
